import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RemarkDetails from './RemarkDetails/RemarkDetails';

import { Heading, Title, Container } from './OperationalRemarkSection.styles.js';

const OperationalRemarkSection = ({ bookingReference, currentRemark }) => (
  <Container>
    <Heading data-testid="operational-remark-header">
      <Title data-testid="operational-remark-title">
        <FormattedMessage id="notes.remark.title" />
      </Title>
    </Heading>
    <RemarkDetails bookingReference={bookingReference} currentRemark={currentRemark} />
  </Container>
);

OperationalRemarkSection.propTypes = {
  bookingReference: PropTypes.string.isRequired,
  currentRemark: PropTypes.string
};

export default OperationalRemarkSection;
